import React, { useEffect, useState, Fragment } from 'react';

import { useLocation } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // --> https://fontawesome.com/v5.15/how-to-use/on-the-web/using-with/react
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons'; // --> https://fontawesome.com/v5.15/how-to-use/on-the-web/using-with/react

import Pagination from '../../organisms/Pagination/Pagination';
import Modal from 'components/atoms/Modal/Modal';
import ErrorTable from 'components/atoms/ErrorTable/ErrorTable';
import Item from 'components/molecules/Item/Item';
import SubItem from 'components/molecules/SubItem/SubItem';
import Spinner from 'components/molecules/Spinner/Spinner';
import ModalContent from 'components/atoms/Modal/ModalContent/ModalContent';

import { SortBtn, PaginationRow } from './TableComponent.styles';
import { TableHeader, TableWrapper, Table, FirstRowHeader } from '../../../assets/styles/sharedStyles/sharedStyles';

const TableComponent = ({
  items,
  error,
  sortColumnDesc,
  sortColumnAsc,
  totalRows,
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  totalConnections,
  setCampaignName,
  onDownload,
  totalTime,
}) => {
  const [dataModal, setDataModal] = useState([]);
  const [isModalActive, setModalActive] = useState(false);
  const [reportModalActive, setReportModalActive] = useState(false);
  const [lastOpenItemId, setLastOpenItemId] = useState(null);
  const [showNested, setShowNested] = useState(false);
  const [rowIndex, setRowIndex] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [versionS] = useState(true);

  let location = useLocation();

  useEffect(() => {
    const leadIdFromUrl = location.pathname;

    if (leadIdFromUrl.includes('!')) {
      const result = leadIdFromUrl.substring(leadIdFromUrl.lastIndexOf('!') + 1);
      if (!!result) {
        addDataToModal({ talk_id: result });
        window.history.pushState('', '', '/items-list');
      }
    }
  }, [location, location.pathname]);

  useEffect(() => {
    const body = document.querySelector('body');
    body.style.overflow = isModalActive ? 'hidden' : 'auto';
  }, [isModalActive]);

  const addDataToModal = (data) => {
    setModalActive(true);
    setDataModal([data]);
  };

  const getColumnSortDesc = (e) => {
    sortColumnDesc(e);
  };

  const getColumnSortAsc = (e) => {
    sortColumnAsc(e);
  };

  return (
    <TableWrapper>
      <Table>
        <TableHeader>
          <FirstRowHeader>
            <th></th>
            <th colSpan={1}>
              Lead ID
              <SortBtn type="button" name="lead_number" onClick={getColumnSortDesc}>
                <FontAwesomeIcon icon={faArrowUp} />
              </SortBtn>
              <SortBtn type="button" name="lead_number" onClick={getColumnSortAsc}>
                <FontAwesomeIcon icon={faArrowDown} />
              </SortBtn>
            </th>
            <th colSpan={1}>Phone Number</th>
            <th colSpan={1}>
              Time
              <SortBtn type="button" name="start_time" onClick={getColumnSortDesc}>
                <FontAwesomeIcon icon={faArrowUp} />
              </SortBtn>
              <SortBtn type="button" name="start_time" onClick={getColumnSortAsc}>
                <FontAwesomeIcon icon={faArrowDown} />
              </SortBtn>
            </th>
            <th colSpan={1}>
              Duration
              <SortBtn type="button" name="duration" onClick={getColumnSortDesc}>
                <FontAwesomeIcon icon={faArrowUp} />
              </SortBtn>
              <SortBtn type="button" name="duration" onClick={getColumnSortAsc}>
                <FontAwesomeIcon icon={faArrowDown} />
              </SortBtn>
            </th>
            <th>Logical Status</th>

            <th>
              Business Status
              <SortBtn type="button" name="business_status_name" onClick={getColumnSortDesc}>
                <FontAwesomeIcon icon={faArrowUp} />
              </SortBtn>
              <SortBtn type="button" name="business_status_name" onClick={getColumnSortAsc}>
                <FontAwesomeIcon icon={faArrowDown} />
              </SortBtn>
            </th>
          </FirstRowHeader>
        </TableHeader>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <Fragment key={index}>
                <Item
                  key={item.talk_id}
                  item={item}
                  otherTalks={item.other_talks}
                  addDataToModal={addDataToModal}
                  isLastOpenItem={lastOpenItemId}
                  setLastOpenItemId={setLastOpenItemId}
                  setShowNested={setShowNested}
                  showNested={showNested}
                  setRowIndex={setRowIndex}
                  rowIndex={rowIndex}
                  all_talks_count={item.all_talks_count}
                  lastOpenItemId={lastOpenItemId}
                />
                {showNested ? (
                  <>
                    {item.other_talks && item.other_talks.length > 0 && item.talk_id === rowIndex
                      ? item.other_talks.map((item, index) => (
                          <Fragment key={index}>
                            <SubItem
                              key={item.talk_id}
                              item={item}
                              addDataToModal={addDataToModal}
                              isLastOpenItem={lastOpenItemId === item.talk_id}
                            />
                          </Fragment>
                        ))
                      : null}
                  </>
                ) : null}
              </Fragment>
            ))
          ) : error ? (
            <ErrorTable label={error} />
          ) : (
            <Spinner />
          )}

          <PaginationRow>
            <td colSpan={7}>
              <Pagination
                totalRows={totalRows}
                rowsPerPage={rowsPerPage}
                totalConnections={totalConnections}
                page={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                onDownload={onDownload}
                totalTime={totalTime}
              />
            </td>
          </PaginationRow>
        </tbody>
      </Table>

      <Modal
        isActive={isModalActive}
        setActive={() => setModalActive(false)}
        setLastOpenItemId={setLastOpenItemId}
        setTabValue={setTabValue}
      >
        <ModalContent
          data={dataModal}
          isActive={isModalActive}
          setLastOpenItemId={setLastOpenItemId}
          tabValue={tabValue}
          setTabValue={setTabValue}
        />
      </Modal>
    </TableWrapper>
  );
};

export default TableComponent;
